// Charge la base commune
import './common.js'

// Styles custom
import './scss/pages/blog'

// Pajination
async function getPajination () {
  import(/* webpackChunkName: "pajination" */ './js/components/pajination.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
    // sur changement de page, on se repositionne sur le début de listing
    $('ul.pagination > li > a').off().on('click', function () {
      const h = $('#header').height()
      const p = $(this).parents('.pajinate-nav').height()
      $('html,body').animate({ scrollTop: $('#blogposts-pagination').offset().top - h - p - 10 }, 300)
    })
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // gestion des pages
  const $d = $('.pajinate')
  if ($d.length) {
    $d.waypoint(function () {
      getPajination()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // css complémentaires à un article en détail
  const $p = $('.blogpost-content')
  if ($p.length) {
    $p.waypoint(function () {
      import(/* webpackChunkName: "blogpostContent", webpackPrefetch: true */ './scss/components/blogpostContent.scss')
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  if ($('#go').length) {
    const t = $('#go')
    $('html, body').animate({
      scrollTop: ($(t).offset().top - $('#header').height() - 50)
    }, 300)
  }
})
